import { Cams, Store, StoreHookReturn } from '@/types/camspec';
import { PTZMessage } from '../../../types/control';
import { CameraModel } from '../types/CameraSettingsModel';

// Module-scoped store and cameras to track PTZ values
let store: Store = {};
let currentPTZ: PTZMessage = {
  pan: 0,
  tilt: 0,
  zoom: 0,
};
const cams: Cams = {};

export const usePTZStore = (): StoreHookReturn => {
  const init = (cameras: CameraModel[]) => {
    // TODO: Initialize PTZ store with camera data if needed
    return;
  };

  const handleChange = (ptzValues: PTZMessage, idx: number) => {
    delete ptzValues.type;
    store = {
      ...store,
      [idx]: ptzValues,
    };
    currentPTZ = ptzValues;
  };

  const setMinimum = (ptzMinValues: PTZMessage, idx: number) => {
    cams[idx].min = ptzMinValues;
  };

  const setMaximum = (ptzMaxValues: PTZMessage, idx: number) => {
    cams[idx].max = ptzMaxValues;
  };

  const getValue = (idx: number) => {
    return store[idx];
  };

  return {
    getValue,
    getCurrentPTZ: () => currentPTZ,
    handleChange,
    init,
    setMinimum,
    setMaximum,
    store,
  };
};
